// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"96e37cccf6959798a59a","3180":"67d067f28e77f6390b9f","9277":"ff727f26f70fda5cc01c"}[chunkId] + ".css";
};